import { addCommas } from '@arema/components/Util';
import React, { useEffect, useMemo, useState } from 'react';
import { Button, Header, Table, Icon, Modal } from 'react-frontier2';
import { useTranslation } from 'react-i18next';
import API from '../API';

interface EventDateStatusModalProps{
	open: boolean,
	title?: string,
	onClose: ()=>void,
	dateId: number,
}

interface EventDateSectionStatus{
	section_id: number,
	section_name: string,
	numbered: boolean,
	ticket_count: number,
	blocked: number,
	tickets: number,
}

var EventDateStatusModal = (props: EventDateStatusModalProps)=>{
	var { t } = useTranslation();
	var [loadError, setLoadError] = useState<string>(null);
	var [status, setStatus] = useState<{
		date_id: number,
		status: EventDateSectionStatus[],
	}>();

	useEffect(()=>{
		if(!props.open){
			setStatus(null);
			setLoadError(null);
		}
	}, [props.open]);

	useEffect(()=>{
		if(!props.dateId || !props.open) return;
		if(status && status?.date_id===props.dateId) return;
		setLoadError(null);
		setStatus(null);
		API.getDateSectionStatus(props.dateId).then(res=>{
			if(res.error) return setLoadError(res.message);
			setStatus({
				date_id: props.dateId,
				status: res.data
			});
		}).catch(err=>{
			setLoadError(t('common.unexpected_code', { code: 'LCL-EVDTSTMDL-1' }));
		});
	}, [props.dateId, props.open, status]);

	var total = useMemo(()=>{
		var total = {
			ticket_count: 0,
			blocked: 0,
			tickets: 0
		}
		if(!status || !status.status) return total;
		for(var i of status.status){
			total.ticket_count += i.ticket_count;
			total.blocked += i.blocked;
			total.tickets += i.tickets;
		}
		return total;
	}, [status]);
	
	return <Modal open={props.open} onClose={props.onClose} size={'small'}>
		<Modal.Header>{props.title || t('estven.title')}</Modal.Header>
		<Modal.Content>
			{(!status || loadError) ? (
				<Header loading={!loadError} text={loadError ? t('common.error') : t('common.loading')} subtext={loadError} />
			) : status.status.length==0 ? (
				<Header text={t('common.error')} subtext={t('estven.no_sections')} />
			) : (
				<Table fitted striped top last>
					<Table.Head data={[['ID', 'Sección', '', 'Aforo', 'Bloqueados', 'Venta', 'Restantes']]} />
					<Table.Body>
						{status.status.map(a=>(
							<Table.Row 
								key={`EVSC-${a.section_id}`} 
								collapsingIndexes={[0, 2, 3, 4, 5, 6]}
								centeredIndexes={[2, 3, 4, 5, 6]}
								data={[
									a.section_id,
									a.section_name,
									<Icon name={a.numbered ? 'chair' : 'ticket'} style={{ marginRight: 0 }} />,
									addCommas(a.ticket_count, false),
									addCommas(a.blocked, false),
									addCommas(a.tickets, false),
									addCommas(a.ticket_count-a.tickets, false),
								]} 
							/>
						))}
					</Table.Body>
					<Table.Divider rowStyle={{ backgroundColor: '#f0f0f0' }} />
					<Table.Row collapsingIndexes={[0, 2, 3, 4, 5, 6]} centeredIndexes={[2, 3, 4, 5, 6]}>
						<Table.Cell colSpan={3} value={'Total'} style={{ textAlign: 'right', fontWeight: 'bold' }} />
						<Table.Cell style={{ textAlign: 'center' }} collapsing value={addCommas(total.ticket_count, false)} />
						<Table.Cell style={{ textAlign: 'center' }} collapsing value={addCommas(total.blocked, false)} />
						<Table.Cell style={{ textAlign: 'center' }} collapsing value={addCommas(total.tickets, false)} />
						<Table.Cell style={{ textAlign: 'center' }} collapsing value={addCommas(total.ticket_count-total.tickets, false)} />
					</Table.Row>
				</Table>
			)}
		</Modal.Content>
		<Modal.Actions>
			<Button text={t('common.close')} onClick={props.onClose} />
		</Modal.Actions>
	</Modal>
}

export default EventDateStatusModal;